import React from "react";

import Collapse from "../../components/Collapse";

export const Head = () => {
  return (
    <head>
      <h1 className="font-bold text-3xl text-center">Notebooks</h1>
      <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/notebook-1.pdf"
      />
      <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/notebook-2-compressed.pdf"
      />
      <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/notebook-3.pdf"
      />
      <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/notebook-4.pdf"
      />
      <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/notebook-5.pdf"
      />
    </head>
  );
};

const Notebooks: React.FC = () => {
  return (
    <main className="mx-auto max-w-7xl">
      <section className="mb-5">
        <Collapse.Title>Introduction</Collapse.Title>
        <p>
          Here you will find the notes for the entire project development
          process. The details and analyses of the experiments are on the
          measurement page. The full description and logic of the project, as
          well as the use of each protocol and the generation of every note
          described here, can be found on the engineering page.
        </p>
      </section>

      <Collapse>
        <Collapse.Title>Bioinformatics</Collapse.Title>
        <Collapse.Content>
          <iframe
            title="1"
            src="https://static.igem.wiki/teams/5058/notebook-1.pdf"
            style={{
              width: "100%",
              height: "100%",
              minHeight: "500px",
              border: "none",
              padding: "20",
            }}
          />
        </Collapse.Content>
      </Collapse>

      <Collapse>
        <Collapse.Title>
          Design and Characterization of Yeast Strains
        </Collapse.Title>
        <Collapse.Content>
          <iframe
            title="2"
            src="https://static.igem.wiki/teams/5058/notebook-2-compressed.pdf"
            style={{
              width: "100%",
              height: "100%",
              minHeight: "500px",
              border: "none",
            }}
          />
        </Collapse.Content>
      </Collapse>

      <Collapse>
        <Collapse.Title>Promoter activity analysis</Collapse.Title>
        <Collapse.Content>
          <iframe
            title="3"
            src="https://static.igem.wiki/teams/5058/notebook-3.pdf"
            style={{
              width: "100%",
              height: "100%",
              minHeight: "500px",
              border: "none",
            }}
          />
        </Collapse.Content>
      </Collapse>

      <Collapse>
        <Collapse.Title>
          Analysis of NR Supplementation in Arabidopsis thaliana
        </Collapse.Title>
        <Collapse.Content>
          <iframe
            src="https://static.igem.wiki/teams/5058/notebook-4.pdf"
            title="4"
            style={{
              width: "100%",
              height: "100%",
              minHeight: "500px",
              border: "none",
            }}
          />
        </Collapse.Content>
      </Collapse>

      <Collapse>
        <Collapse.Title>
          Optimization of NR Production in Bioreactor
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/notebook-5.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>

      <p>
        <img
          className={"block mx-auto max-w-60"}
          src="https://static.igem.wiki/teams/5058/yob3-final-da-pg.svg"
          alt=""
        />
      </p>
    </main>
  );
};

export default Notebooks;
